import { useState } from 'react';
import { Box, IconButton, Tooltip, Typography, Accordion, AccordionSummary, AccordionDetails  } from '@mui/material';
import GraphTypesConfig from './GraphTypesConfig';
import { ReactComponent as DropDownIcon } from "../../assets/icons/icon-angle-down.svg"
import { CustomTooltip } from '../../utils/Reusables';
// ----------------------------------------------------------------------

export default function GraphTypes({ reportDetails, setChartHandler,setSelectedChart,selectedChart}) {
    const setChart = (graph) => {
        setSelectedChart(graph.value)
        setChartHandler(graph)
    }
    return (
      <>
        <Box className="report-new-charts">
          <Accordion defaultExpanded className="filter_accordian">
            <AccordionSummary
            expandIcon={<DropDownIcon />}
            aria-controls="report-new-charts-content"
            id="report-new-charts-header"
            className="report-new-charts-header filter_accordian_summary"
            >
              <Typography className="report-new-charts-title"  variant="h4" noWrap>Visual Type</Typography>
            </AccordionSummary>
            <AccordionDetails  className="report-new-charts-items filter_accordian_details">
              {GraphTypesConfig.map((graph, i) =>
                <CustomTooltip key={i} title={graph.label}>
                  <IconButton className='form-icon-btn' variant="outlined" key={i} onClick={() => setChart(graph)}>
                    {graph.icon({ selected: selectedChart == graph.value })}
                  </IconButton>
                </CustomTooltip>
              )}
            </AccordionDetails>
          </Accordion>
        </Box>
          
          
      </>
    )
}
